module.exports = __webpack_public_path__ + "img/saiglobal_grey.3ca16edf.svg";